import FItem from '.';

export default class FItemArray extends FItem {
  set(value = []) {
    super.set(value);
  }

  setValidatorRequire(message = 'Обязательное') {
    this.setValidator((value) => {
      if (!Array.isArray(value) || !value?.length) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    }, true);
    return this;
  }
}
